import { render } from "./MyProspectingLayout.vue?vue&type=template&id=50b9049f&scoped=true"
import script from "./MyProspectingLayout.vue?vue&type=script&lang=js"
export * from "./MyProspectingLayout.vue?vue&type=script&lang=js"

import "./MyProspectingLayout.vue?vue&type=style&index=0&id=50b9049f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b9049f"]])

export default __exports__